<template>
  <div>You were logged out</div>
</template>

<script>
  import { logout } from '@/keycloak'

  export default {
    name: 'Logout',
    beforeRouteEnter: logout
  }
</script>
